import axios from './request'
import { prop } from 'ramda'

/**
 * @typedef City
 * @property {string} ID
 * @property {string} NAME
 */

/**
 *
 * @param {string} query
 * @param {import('axios').AxiosRequestConfig?} config
 * @returns {Promise<City[]>}
 */
export default function getServiceCities(query, { params, ...config } = {}) {
	return axios.get('/api/Location/getServiceCities/', {
		...config,
		params: {
			...params,
			query,
		},
	})
		.then(({ data }) => data)
		.then(prop('data'))
}
